import { FC } from 'react'
import ButtonStyle from '@enums/ButtonStyle'
import ReportStatus from '@enums/ReportStatus'
import DownloadButton from '@organisms/DownloadButton'
import { File } from '@models/file'
import { useLazyGetFileQuery } from '@services/files'

type Props = {
  status: ReportStatus
  reportFile: File
}

const DownloadReportButton: FC<Props> = ({ status, reportFile }) => {
  const [getFile, { isLoading }] = useLazyGetFileQuery()

  const handleClick = () => {
    if (!isLoading) {
      void getFile({
        path: reportFile.filePath,
        name: reportFile.originalName,
      })
    }
  }

  return (
    <DownloadButton
      buttonStyle={ButtonStyle.PRIMARY}
      disabled={status !== ReportStatus.Done}
      onClick={handleClick}
      isLoading={isLoading}
    />
  )
}

export default DownloadReportButton
